import {
  Event,
  EventsPeriod,
  CombinedEventStatistics,
  Presenter,
  Session,
  EventsCharts,
  EventDetails,
  ViewOfTheRoom,
  EventScores,
  EventDocument,
} from "../../api";

export const FETCH_STATISTICS_FOR_PERIOD = "FETCH_STATISTICS_FOR_PERIOD";
export const FETCH_FILTERED_STATISTICS = "FETCH_FILTERED_STATISTICS";
export const FETCH_CHARTS_FOR_PERIOD = "FETCH_CHARTS_FOR_PERIOD";
export const FETCH_EVENTS_FOR_PERIOD = "FETCH_EVENTS_FOR_PERIOD";
export const FETCH_EVENTS_BY_ID = "FETCH_EVENTS_BY_ID";
export const FETCH_FILTERED_EVENTS = "FETCH_FILTERED_EVENTS";
export const FETCH_DIARY_EVENTS = "FETCH_DIARY_EVENTS";
export const FETCH_DETAILS_FOR_EVENT = "FETCH_DETAILS_FOR_EVENT";
export const FETCH_DOCUMENT_FOR_EVENT = "FETCH_DOCUMENT_FOR_EVENT";
export const FETCH_SCORES_FOR_EVENT = "FETCH_SCORES_FOR_EVENT";
export const FETCH_VIEWS_FOR_EVENT = "FETCH_VIEWS_FOR_EVENT";

export interface EventsFilters {
  name?: string;
  round?: string;
  type?: string[];
}

//
// ASYNC ACTIONS
//

// Statistics

export interface FetchStatisticsForPeriodAction {
  type: typeof FETCH_STATISTICS_FOR_PERIOD;
  period: EventsPeriod;
}
interface RequestStatisticsForPeriodAction {
  type: "REQUEST_STATISTICS_FOR_PERIOD";
  period: EventsPeriod;
}
interface SetStatisticsForPeriodAction {
  type: "SET_STATISTICS_FOR_PERIOD";
  period: EventsPeriod;
  data: CombinedEventStatistics;
}
interface SetStatisticsForPeriodErrorAction {
  type: "SET_STATISTICS_FOR_PERIOD_ERROR";
  period: EventsPeriod;
}

export interface FetchFilteredStatisticsAction {
  type: typeof FETCH_FILTERED_STATISTICS;
  period: EventsPeriod;
  filters: EventsFilters;
}
interface RequestFilteredStatisticsAction {
  type: "REQUEST_FILTERED_STATISTICS";
}
interface SetFilteredStatisticsAction {
  type: "SET_FILTERED_STATISTICS";
  data: CombinedEventStatistics;
}
interface SetFilteredStatisticsErrorAction {
  type: "SET_FILTERED_STATISTICS_ERROR";
}

// Charts

export interface FetchChartsForPeriodAction {
  type: typeof FETCH_CHARTS_FOR_PERIOD;
  period: EventsPeriod;
}
interface RequestChartsForPeriodAction {
  type: "REQUEST_CHARTS_FOR_PERIOD";
  period: EventsPeriod;
}
interface SetChartsForPeriodAction {
  type: "SET_CHARTS_FOR_PERIOD";
  period: EventsPeriod;
  data: EventsCharts;
}
interface SetChartsForPeriodErrorAction {
  type: "SET_CHARTS_FOR_PERIOD_ERROR";
  period: EventsPeriod;
}

// List

export interface FetchEventsForPeriodAction {
  type: typeof FETCH_EVENTS_FOR_PERIOD;
  period: EventsPeriod;
}
interface RequestEventsForPeriodAction {
  type: "REQUEST_EVENTS_FOR_PERIOD";
  period: EventsPeriod;
}
interface SetEventsForPeriodAction {
  type: "SET_EVENTS_FOR_PERIOD";
  period: EventsPeriod;
  events: Event[];
}
interface SetEventsForPeriodErrorAction {
  type: "SET_EVENTS_FOR_PERIOD_ERROR";
  period: EventsPeriod;
}

export interface FetchFilteredEventsAction {
  type: typeof FETCH_FILTERED_EVENTS;
  period: EventsPeriod;
  filters: EventsFilters;
}
interface RequestFilteredEventsAction {
  type: "REQUEST_FILTERED_EVENTS";
}
interface SetFilteredEventsAction {
  type: "SET_FILTERED_EVENTS";
  ids: string[];
}
interface SetFilteredEventsErrorAction {
  type: "SET_FILTERED_EVENTS_ERROR";
}

// By ID

export interface FetchEventsByIdAction {
  type: typeof FETCH_EVENTS_BY_ID;
  eventIds: string[];
}
interface RequestEventsByIdAction {
  type: "REQUEST_EVENTS_BY_ID";
  eventIds: string[];
}

// Event details

export interface FetchDetailsForEventAction {
  type: typeof FETCH_DETAILS_FOR_EVENT;
  eventId: string;
}

export interface RequestEventDetailsAction {
  type: "REQUEST_EVENT_DETAILS",
  eventId: string;
}
interface SetEventDetailsAction extends EventDetails {
  type: "SET_EVENT_DETAILS",
  eventId: string;
}
interface SetEventDetailsErrorAction {
  type: "SET_EVENT_DETAILS_ERROR",
  eventId: string;
}

// Event document

export interface FetchDocumentForEventAction {
  type: typeof FETCH_DOCUMENT_FOR_EVENT;
  eventId: string;
  ticketId: string;
}

export interface RequestEventDocumentAction {
  type: "REQUEST_EVENT_DOCUMENT",
  eventId: string;
  ticketId: string;
}
interface SetEventDocumentAction extends EventDocument {
  type: "SET_EVENT_DOCUMENT",
  eventId: string;
  ticketId: string;
}
interface SetEventDocumentErrorAction {
  type: "SET_EVENT_DOCUMENT_ERROR",
  eventId: string;
  ticketId: string;
}

// Event scores

export interface FetchScoresForEventAction {
  type: typeof FETCH_SCORES_FOR_EVENT;
  eventId: string;
  ticketId: string;
}

export interface RequestEventScoresAction {
  type: "REQUEST_EVENT_SCORES",
  eventUid: string,
}
interface SetEventScoresAction extends EventScores {
  type: "SET_EVENT_SCORES",
  eventUid: string,
}
interface SetEventScoresErrorAction {
  type: "SET_EVENT_SCORES_ERROR",
  eventUid: string,
}

// Event views

export interface FetchViewsForEventAction {
  type: typeof FETCH_VIEWS_FOR_EVENT;
  eventId: string;
  ticketId: string;
}

export interface RequestEventViewsAction {
  type: "REQUEST_EVENT_VIEWS",
  eventId: string;
  ticketId: string;
}
interface SetEventViewsAction {
  type: "SET_EVENT_VIEWS",
  eventId: string;
  ticketId: string;
  data: ViewOfTheRoom[];
}
interface SetEventViewsErrorAction {
  type: "SET_EVENT_VIEWS_ERROR",
  eventId: string;
  ticketId: string;
}

// Diary

export interface FetchDiaryEventsAction {
  type: typeof FETCH_DIARY_EVENTS;
  date: Date;
}
interface RequestDiaryEventsAction {
  type: "REQUEST_DIARY_EVENTS";
  key: string;
}
interface SetDiaryEventsAction {
  type: "SET_DIARY_EVENTS";
  key: string;
  ids: string[];
}
interface SetDiaryEventsErrorAction {
  type: "SET_DIARY_EVENTS_ERROR";
  key: string;
}

//
// SET ACTIONS
//

interface SetEventsPeriodAction {
  type: "SET_EVENTS_PERIOD";
  period: EventsPeriod;
}

interface SetDiaryDateAction {
  type: "SET_DIARY_DATE";
  date: Date;
}

interface ClearFiltersAction {
  type: "CLEAR_FILTERS";
}

interface AddEventsAction {
  type: "ADD_EVENTS";
  events: Event[];
}

interface AddSessionsAction {
  type: "ADD_SESSIONS";
  sessions: Session[];
}

interface AddPresentersAction {
  type: "ADD_PRESENTERS";
  presenters: Presenter[];
}

//
// ALL ACTIONS
//

export type KnownAction =
  | FetchStatisticsForPeriodAction
  | RequestStatisticsForPeriodAction
  | SetStatisticsForPeriodAction
  | SetStatisticsForPeriodErrorAction
  | FetchFilteredStatisticsAction
  | RequestFilteredStatisticsAction
  | SetFilteredStatisticsAction
  | SetFilteredStatisticsErrorAction
  | FetchChartsForPeriodAction
  | RequestChartsForPeriodAction
  | SetChartsForPeriodAction
  | SetChartsForPeriodErrorAction
  | FetchEventsForPeriodAction
  | RequestEventsForPeriodAction
  | SetEventsForPeriodAction
  | SetEventsForPeriodErrorAction
  | FetchFilteredEventsAction
  | RequestFilteredEventsAction
  | SetFilteredEventsAction
  | SetFilteredEventsErrorAction
  | FetchDiaryEventsAction
  | RequestDiaryEventsAction
  | SetDiaryEventsAction
  | SetDiaryEventsErrorAction
  | FetchDetailsForEventAction
  | FetchViewsForEventAction
  | RequestEventViewsAction
  | SetEventViewsAction
  | SetEventViewsErrorAction
  | RequestEventDetailsAction
  | SetEventDetailsAction
  | SetEventDetailsErrorAction
  | RequestEventDocumentAction
  | SetEventDocumentAction
  | SetEventDocumentErrorAction
  | RequestEventScoresAction
  | SetEventScoresAction
  | SetEventScoresErrorAction
  | SetEventsPeriodAction
  | SetDiaryDateAction
  | ClearFiltersAction
  | AddEventsAction
  | AddPresentersAction
  | AddSessionsAction;

// FETCH

export const fetchStatistics = (
  period: EventsPeriod,
  filters?: EventsFilters
): FetchStatisticsForPeriodAction | FetchFilteredStatisticsAction =>
  filters
    ? {
      type: "FETCH_FILTERED_STATISTICS",
      period,
      filters,
    }
    : {
      type: "FETCH_STATISTICS_FOR_PERIOD",
      period,
    };

export const fetchCharts = (
  period: EventsPeriod
): FetchChartsForPeriodAction => ({
  type: "FETCH_CHARTS_FOR_PERIOD",
  period,
});

export const fetchEvents = (
  period: EventsPeriod,
  filters?: EventsFilters
): FetchEventsForPeriodAction | FetchFilteredEventsAction =>
  filters
    ? {
      type: "FETCH_FILTERED_EVENTS",
      period,
      filters,
    }
    : {
      type: "FETCH_EVENTS_FOR_PERIOD",
      period,
    };

export const fetchDiaryEvents = (date: Date): FetchDiaryEventsAction => ({
  type: "FETCH_DIARY_EVENTS",
  date,
});

export const fetchEventsById = (eventIds: string[]): FetchEventsByIdAction => ({
  type: "FETCH_EVENTS_BY_ID",
  eventIds,
});

export const fetchEventDetails = (
  eventId: string,
): FetchDetailsForEventAction => ({
  type: "FETCH_DETAILS_FOR_EVENT",
  eventId,
});

export const fetchEventDocument = (
  eventId: string,
  ticketId: string,
): FetchDocumentForEventAction => ({
  type: "FETCH_DOCUMENT_FOR_EVENT",
  eventId,
  ticketId,
});

export const fetchEventScores = (
  eventId: string,
  ticketId: string,
): FetchScoresForEventAction => ({
  type: "FETCH_SCORES_FOR_EVENT",
  eventId,
  ticketId,
});

export const fetchEventViews = (
  eventId: string,
  ticketId: string
): FetchViewsForEventAction => ({
  type: "FETCH_VIEWS_FOR_EVENT",
  eventId,
  ticketId,
});

// SETTERS

export const setEventsPeriod = (
  period: EventsPeriod
): SetEventsPeriodAction => ({
  type: "SET_EVENTS_PERIOD",
  period,
});

export const setDiaryDate = (date: Date): SetDiaryDateAction => ({
  type: "SET_DIARY_DATE",
  date,
});

export const addEvents = (events: Event[]): AddEventsAction => ({
  type: "ADD_EVENTS",
  events,
});

export const addSessions = (
  sessions: Session[]
): AddSessionsAction => ({
  type: "ADD_SESSIONS",
  sessions,
});

export const addPresenters = (
  presenters: Presenter[]
): AddPresentersAction => ({
  type: "ADD_PRESENTERS",
  presenters,
});

export const setStatisticsForPeriod = (
  period: EventsPeriod,
  data: CombinedEventStatistics
): SetStatisticsForPeriodAction => ({
  type: "SET_STATISTICS_FOR_PERIOD",
  period,
  data,
});

export const setStatisticsForPeriodLoading = (
  period: EventsPeriod
): RequestStatisticsForPeriodAction => ({
  type: "REQUEST_STATISTICS_FOR_PERIOD",
  period,
});

export const setStatisticsForPeriodError = (
  period: EventsPeriod
): SetStatisticsForPeriodErrorAction => ({
  type: "SET_STATISTICS_FOR_PERIOD_ERROR",
  period,
});

export const setFilteredStatistics = (
  data: CombinedEventStatistics
): SetFilteredStatisticsAction => ({
  type: "SET_FILTERED_STATISTICS",
  data,
});

export const setFilteredStatisticsLoading = (): RequestFilteredStatisticsAction => ({
  type: "REQUEST_FILTERED_STATISTICS",
});

export const setFilteredStatisticsError = (): SetFilteredStatisticsErrorAction => ({
  type: "SET_FILTERED_STATISTICS_ERROR",
});

export const setChartsForPeriod = (
  period: EventsPeriod,
  data: EventsCharts
): SetChartsForPeriodAction => ({
  type: "SET_CHARTS_FOR_PERIOD",
  period,
  data,
});

export const setChartsForPeriodLoading = (
  period: EventsPeriod
): RequestChartsForPeriodAction => ({
  type: "REQUEST_CHARTS_FOR_PERIOD",
  period,
});

export const setChartsForPeriodError = (
  period: EventsPeriod
): SetChartsForPeriodErrorAction => ({
  type: "SET_CHARTS_FOR_PERIOD_ERROR",
  period,
});

export const setEventsForPeriod = (
  period: EventsPeriod,
  events: Event[]
): SetEventsForPeriodAction => ({
  type: "SET_EVENTS_FOR_PERIOD",
  period,
  events,
});

export const setEventsForPeriodLoading = (
  period: EventsPeriod
): RequestEventsForPeriodAction => ({
  type: "REQUEST_EVENTS_FOR_PERIOD",
  period,
});

export const setEventsForPeriodError = (
  period: EventsPeriod
): SetEventsForPeriodErrorAction => ({
  type: "SET_EVENTS_FOR_PERIOD_ERROR",
  period,
});

export const setFilteredEvents = (
  ids: string[]
): SetFilteredEventsAction => ({
  type: "SET_FILTERED_EVENTS",
  ids,
});

export const setFilteredEventsLoading = (): RequestFilteredEventsAction => ({
  type: "REQUEST_FILTERED_EVENTS",
});

export const setFilteredEventsError = (): SetFilteredStatisticsErrorAction => ({
  type: "SET_FILTERED_STATISTICS_ERROR",
});

export const setDiaryEvents = (
  key: string,
  ids: string[]
): SetDiaryEventsAction => ({
  type: "SET_DIARY_EVENTS",
  key,
  ids,
});

export const setDiaryEventsLoading = (
  key: string
): RequestDiaryEventsAction => ({
  type: "REQUEST_DIARY_EVENTS",
  key,
});

export const setDiaryEventsError = (
  key: string
): SetDiaryEventsErrorAction => ({
  type: "SET_DIARY_EVENTS_ERROR",
  key,
});

export const setEventDetails = (
  eventId: string,
  data: EventDetails
): SetEventDetailsAction => ({
  type: "SET_EVENT_DETAILS",
  eventId,
  ...data,
});

export const setEventDetailsLoading = (
  eventId: string,
): RequestEventDetailsAction => ({
  type: "REQUEST_EVENT_DETAILS",
  eventId,
});

export const setEventDetailsError = (
  eventId: string,
): SetEventDetailsErrorAction => ({
  type: "SET_EVENT_DETAILS_ERROR",
  eventId,
});

export const setEventDocument = (
  eventId: string,
  ticketId: string,
  data: EventDocument
): SetEventDocumentAction => ({
  type: "SET_EVENT_DOCUMENT",
  eventId,
  ticketId,
  ...data,
});

export const setEventDocumentLoading = (
  eventId: string,
  ticketId: string
): RequestEventDocumentAction => ({
  type: "REQUEST_EVENT_DOCUMENT",
  eventId,
  ticketId,
});

export const setEventDocumentError = (
  eventId: string,
  ticketId: string
): SetEventDocumentErrorAction => ({
  type: "SET_EVENT_DOCUMENT_ERROR",
  eventId,
  ticketId,
});

export const setEventScores = (
  eventUid: string,
  data: EventScores
): SetEventScoresAction => ({
  type: "SET_EVENT_SCORES",
  eventUid,
  ...data,
});

export const setEventScoresLoading = (
  eventUid: string
): RequestEventScoresAction => ({
  type: "REQUEST_EVENT_SCORES",
  eventUid,
});

export const setEventScoresError = (
  eventUid: string,
): SetEventScoresErrorAction => ({
  type: "SET_EVENT_SCORES_ERROR",
  eventUid,
});

export const setEventViews = (
  eventId: string,
  ticketId: string,
  data: ViewOfTheRoom[]
): SetEventViewsAction => ({
  type: "SET_EVENT_VIEWS",
  eventId,
  ticketId,
  data,
});

export const setEventViewsLoading = (
  eventId: string,
  ticketId: string
): RequestEventViewsAction => ({
  type: "REQUEST_EVENT_VIEWS",
  eventId,
  ticketId,
});

export const setEventViewsError = (
  eventId: string,
  ticketId: string
): SetEventViewsErrorAction => ({
  type: "SET_EVENT_VIEWS_ERROR",
  eventId,
  ticketId,
});

// DISPLAY

export const clearFilters = (): ClearFiltersAction => ({
  type: "CLEAR_FILTERS",
});
